<div class="p-6">
  @if (meterFrames.length > 0) {

    <app-tabs [(activeTab)]="currentActiveTab">
      @for (meterFrame of meterFrames; track meterFrame.id) {
        <app-tab [title]="meterFrame.identification ?? ''">
          <app-card>
            <div class="flex gap-4">
              <div class="w-1/4">
                <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold">
                  {{ 'frame.masterdata' | translate }}
                </div>
                @if (meterFrame.meterFrameType === 'Serial') {
                  <app-value-details [collection]="meterFrameSerialMasterData" [data]="meterFrame"></app-value-details>
                } @else if (meterFrame.meterFrameType === 'Parallel') {
                  <app-value-details [collection]="meterFrameParallelMasterData" [data]="meterFrame"></app-value-details>
                } @else if (meterFrame.meterFrameType === 'Station') {
                  <app-value-details [collection]="meterFrameStationMasterData" [data]="meterFrame"></app-value-details>
                } @else {
                  <app-value-details [collection]="meterFramePrimaryMasterData" [data]="meterFrame"></app-value-details>
                  <div class="p-2 font-semibold">
                    {{ 'meter.conversionFactor' | translate }}
                  </div>
                  <app-value-details [collection]="meterConversionFactorMasterData" [data]="meterFrame"></app-value-details>
                }
              </div>
              @if (meterFrameMeter.has(meterFrame.id!)) {
                <div class="w-3/4">
                  <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold">
                    {{ 'meter.title' | translate }}
                  </div>
                  <div class="flex gap-4">
                    <div class="w-1/3">
                      <div class="p-2 font-semibold">
                        {{ 'meter.information' | translate }}
                      </div>
                      <app-value-details
                        [collection]="meterInformationMasterData"
                        [data]="meterFrameMeter.get(meterFrame.id!)">
                      </app-value-details>
                      <div class="p-2 font-semibold">
                        {{ 'meter.conversionFactor' | translate }}
                      </div>
                      <app-value-details [collection]="meterConversionFactorMasterData" [data]="meterFrameMeter.get(meterFrame.id!)"></app-value-details>
                    </div>
                    <div class="w-1/3">
                      <div class="p-2 font-semibold">
                        {{ 'meter.product' | translate }}
                      </div>
                      <app-value-details
                        [collection]="meterProductMasterData"
                        [data]="meterFrameMeter.get(meterFrame.id!)">
                      </app-value-details>
                    </div>
                    <div class="w-1/3">
                      <div class="p-2 font-semibold">
                        {{ 'meter.quadrant' | translate }}
                      </div>
                      <app-value-details
                        [collection]="meterQuadrantMasterData"
                        [data]="meterFrameMeter.get(meterFrame.id!)">
                      </app-value-details>
                    </div>
                  </div>
                </div>
              }
            </div>
            @if (meterMeteringPoint.has(meterFrame.id!) && meterMeteringPoint.get(meterFrame.id!)) {
              <div class="flex flex-col gap-4">
                <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold">
                  {{ 'meter.relatedMeteringPoints' | translate }}
                </div>
                <div class="flex flex-row">
                  <app-table
                    [config]="meteringPointDirectRelationConfig"
                    [data]="meterMeteringPoint.get(meterFrame.id!)!"></app-table>
                </div>
              </div>
            }

            <div class="my-4">
              <button
                type="button"
                class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold flex justify-between items-center w-full text-left"
                (click)="toggleConversionFactors(meterFrame.id!)">
                {{ 'conversionFactorHistory.sectionTitle' | translate }}
                <svg
                  class="w-4 h-4 transition-transform duration-200"
                  [class.rotate-180]="openConversionFactors.has(meterFrame.id!)"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              @if (openConversionFactors.has(meterFrame.id!)) {
                <div class="flex flex-col gap-6 mt-4 mb-6">
                  <div>
                    <div class="p-2 font-semibold text-sm">
                      {{ 'conversionFactorHistory.meterframeTitle' | translate }}
                    </div>
                    <app-table
                      [config]="meterframeConversionFactorTableConfig"
                      [data]="meterFrameConversionFactors.get(meterFrame.id!) ?? []">
                    </app-table>
                  </div>
                  <div>
                    <div class="p-2 font-semibold text-sm">
                      {{ 'conversionFactorHistory.meterTitle' | translate }}
                    </div>
                    <app-table
                      [config]="meterConversionFactorTableConfig"
                      [data]="meterConversionFactors.get(meterFrame.id!) ?? []">
                    </app-table>
                  </div>
                </div>
              }
            </div>

            @if (meterFrameHistory.has(meterFrame.id!) && meterFrameHistory.get(meterFrame.id!)?.length) {
              <div class="flex flex-col gap-4">
                <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold">
                  {{ 'meteringpoint.history' | translate }}
                </div>
                <div class="flex flex-row">
                  <app-table
                    [config]="meterFrameHistoryTableConfig"
                    [data]="meterFrameHistory.get(meterFrame.id!)!"
                    [(selectedElements)]="selectedElements"></app-table>
                </div>
              </div>
              @if (selectedElements.length > 0) {
                <div class="table-wrapper relative shadow-sm mt-4">
                  <div class="border border-gray-200 dark:border-dark-border rounded-md overflow-hidden">
                    <table
                      class="w-full rounded-md table-fixed border-collapse overflow-hidden bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border">
                      <tbody>
                        @for (col of dataColumns; track i; let i = $index) {
                          <tr class="border-b border-gray-200 dark:border-dark-border odd:bg-gray-50 dark:odd:bg-dark-hover">
                            <th
                              class="w-64 text-left px-2 py-2 font-normal border-r border-gray-200 dark:border-dark-border dark:text-dark-text">{{ col.title | translate }}
                            </th>
                            @for (element of selectedElements; track element; let j = $index) {
                              <td class="text-primary dark:text-dark-text py-2 px-2 border-slate-200 truncate">
                                <app-table-cell
                                  [config]="col"
                                  [data]="element"
                                ></app-table-cell>
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            }
          </app-card>
        </app-tab>
      }
    </app-tabs>
  } @else if (dataFetched) {
    <div class="flex justify-center items-center h-full">
      <span class="bg-slate-100 dark:bg-dark-hover border-slate-200 dark:border-dark-border border px-2 py-1 text-sm text-secondary dark:text-dark-muted rounded">
        {{ 'meterFrame.noMeterFrames' | translate }}
      </span>
    </div>
  }
</div>
